// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__gWWK7","status":"styles_status__xCqyv"};